var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesAlertsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-alerts-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-alerts-icon_svg__cls-1{fill:#010101;stroke-width:0}.websites-alerts-icon_svg__cls-4,.websites-alerts-icon_svg__cls-5{fill:#e84b0f;stroke:#010101;stroke-miterlimit:10;stroke-width:2px}.websites-alerts-icon_svg__cls-5{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.09 18.74c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-5",
    d: "M54.03 33.62L30.5 18.46c-.64-.46-1.52-.46-2.16 0L5.08 33.62c-.24.18-.36.46-.36.73v32.49c0 .52.39.91.91.91h47.85c.52 0 .91-.39.91-.91V34.35c0-.3-.12-.58-.36-.73z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9eaeb",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M10.18 20.22h38.71v32.37H10.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-1",
    d: "M22.93 26.36h2.58v8.41h-2.58z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-4",
    d: "M36.14 41.96H22.93v-9.5l6.62-6.1 6.59 6.1v9.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.38 33.89l8.17-7.53 8.17 7.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-1",
    d: "M27.52 36.29h4.07v5.68h-4.07z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-5",
    d: "M53.48 67.74H31.31V48.43c.15-.43.46-.82.91-1.03l22.17-11.05v30.49c0 .52-.39.91-.91.91zM5.63 67.74H27.8V48.43c-.15-.43-.46-.82-.91-1.03L4.72 36.35v30.49c0 .52.39.91.91.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-alerts-icon_svg__cls-5",
    d: "M5.63 67.74h47.85c.52 0 .91-.39.91-.91l-23.87-18.8c-.67-.52-1.61-.52-2.28 0L4.68 66.83c.03.52.43.91.94.91z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "websites-alerts-icon_svg__cls-4",
    cx: 48.92,
    cy: 20.22,
    r: 6.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93 20.37c.3.3.46.67.46 1.15 0 .39-.09.73-.3 1.06-.21.3-.49.55-.88.7-.36.18-.82.24-1.34.24-.46 0-.88-.06-1.34-.21s-.79-.33-1.09-.55l.61-1.12c.27.21.55.39.82.49.3.12.58.15.88.15.33 0 .61-.06.79-.21s.27-.33.27-.58-.09-.43-.27-.58c-.18-.12-.46-.18-.79-.18h-1.03v-.88l1.43-1.37h-2.37v-1.24h4.31v.94l-1.67 1.55.33.06c.49.09.88.27 1.18.58z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
export default SvgWebsitesAlertsIcon;